import { jsxs as h, jsx as i } from "react/jsx-runtime";
import { c as r } from "./index-65016bfa.mjs";
import { createContext as X, useContext as Y, useRef as Z, useState as j, useEffect as H, useCallback as k } from "react";
import a, { css as s } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as P } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import { b as w, U as D } from "./useSlots-a1aa6a84.mjs";
import { c as tt } from "./cloneSlots-333ddef1.mjs";
import { DropdownMenu as B } from "./dropdownMenu.js";
import { Icon as et } from "./icon.js";
import { u as R } from "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import { Tag as U } from "./tags.js";
import { m as ot, A as ct } from "./index-5d51183d.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./index-2be68378.mjs";
import "react-dom";
import "./useWindowSize-88e90e04.mjs";
import "./checkbox.js";
import "./label-33699561.mjs";
import "./popupTip.js";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./Aria-f5e019e2.mjs";
import "./button.js";
import "./closeButton.js";
import "./iconButton.js";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
import "./helperText-d9646f54.mjs";
import "./menu.js";
import "./textInput.js";
import "./radio.js";
import "@fcamna/shared-icons";
import "./childrenCountCheck-785fa19a.mjs";
import "./tslib.es6-59e1c9d8.mjs";
const K = X({}), it = a.div`
  &.AccordionItem {
    ${({
  theme: {
    components: { accordionV1: t }
  }
}) => s(t.AccordionItem)};
  }
`, nt = a.div`
  &.AccordionItem__summary {
    ${({
  theme: {
    components: { accordionV1: t }
  }
}) => s(t.Summary)};
  }
`, mt = a.div`
  &.AccordionItem__summary-title-wrapper {
    ${({
  theme: {
    components: { accordionV1: t }
  }
}) => s(t.TitleWrapper)};
  }
`, rt = a.div`
  &.AccordionItem__summary-leading-icon {
    ${({
  theme: {
    components: { accordionV1: t }
  }
}) => s(t.LeadingIcon)};
  }
`, at = a.div`
  &.AccordionItem__summary-title {
    ${({
  theme: {
    components: { accordionV1: t }
  }
}) => s(t.Title)};
  }
`, st = a.span`
  &.AccordionItem__summary-trailing-icon {
    ${({
  theme: {
    components: { accordionV1: t }
  }
}) => s(t.TrailingIcon)};
  }
`, lt = a(ot.div)`
  &.AccordionItem__content {
    ${({
  theme: {
    components: { accordionV1: t }
  }
}) => s(t.Content)};
  }
`, dt = ({
  children: t,
  title: l,
  subTitle: A,
  id: c,
  icon: y,
  boxVariation: g,
  disabled: o,
  inactive: u,
  isAnimate: S = !0,
  openAccordian: _,
  setOpenAccordian: V,
  openAccordion: d = _,
  setOpenAccordion: f = V,
  accessibilityOptions: W = {},
  className: q,
  dataTestId: Q,
  _isDropDownMenu: N,
  _dropDownProps: n,
  ...z
}) => {
  var L;
  const { activeAccordionItemId: v, setActiveAccordionItemId: T, isSingleSelect: I, isBoxVariant: $ = g } = Y(K), b = Z(null), [m, E] = j(
    typeof d > "u" && I ? v === c : d
  ), F = w(t, { tags: U }, D.LAST);
  H(() => {
    E(typeof d > "u" && I ? v === c : d);
  }, [d, I, v, c]);
  const G = R("button", {
    ...W,
    ariaExpanded: !!m,
    ariaControls: `accordion-content-${c}`,
    ariaDisabled: o || !1
  }), J = R("region", {
    ariaHidden: !!m
  }), x = k(
    (e) => {
      if (u || o)
        return;
      const p = e.currentTarget.dataset.itemId;
      typeof d > "u" && I && T((C) => C === p ? null : p), typeof d > "u" && E((C) => !C), f == null || f(e, p, !m);
    },
    [u, o, I, d, m, T, f]
  ), M = k(
    (e) => {
      e.target === b.current && (e.code === "Enter" || e.code === "Space") && x(e);
    },
    [x]
  );
  return /* @__PURE__ */ h(
    it,
    {
      className: r([
        "AccordionItem",
        {
          "AccordionItem--disabled": o,
          "AccordionItem--inactive": u,
          "AccordionItem--box": $
        }
      ]),
      tabIndex: o ? -1 : 0,
      ...G,
      onKeyDown: M,
      ref: b,
      "data-testid": Q,
      ...z,
      children: [
        /* @__PURE__ */ h(
          nt,
          {
            className: r([
              "AccordionItem__summary",
              {
                "AccordionItem__summary--disabled": o,
                "AccordionItem__summary--inactive": u,
                "AccordionItem__summary--box": $,
                "AccordionItem__summary--open": m,
                "AccordionItem__summary--dropdown": N
              },
              q
            ]),
            "data-item-id": c,
            onClick: o ? void 0 : x,
            children: [
              /* @__PURE__ */ h(
                mt,
                {
                  className: r([
                    "AccordionItem__summary-title-wrapper",
                    {
                      "AccordionItem__summary-title-wrapper--disabled": o,
                      "AccordionItem__summary-title-wrapper--open": m,
                      "AccordionItem__summary-title-wrapper--dropdown": N
                    }
                  ]),
                  children: [
                    y && /* @__PURE__ */ i(
                      rt,
                      {
                        "data-component": "accordion-icon-wrapper",
                        className: r([
                          "AccordionItem__summary-leading-icon",
                          { "AccordionItem__summary-leading-icon--disabled": o }
                        ]),
                        children: y
                      }
                    ),
                    /* @__PURE__ */ h(
                      at,
                      {
                        className: r([
                          "AccordionItem__summary-title",
                          {
                            "AccordionItem__summary-title--disabled": o,
                            "AccordionItem__summary-title--open": m
                          }
                        ]),
                        children: [
                          tt(F.tags, (e, p) => /* @__PURE__ */ i(
                            U,
                            {
                              title: e.title,
                              className: "accordion-title-tag"
                            },
                            p
                          )),
                          /* @__PURE__ */ i("h5", { "data-component": "accordion-title-wrapper", children: l }),
                          A && [].concat(A).filter(Boolean).map((e) => /* @__PURE__ */ i("h6", { children: e }))
                        ]
                      }
                    ),
                    !u && /* @__PURE__ */ i(
                      st,
                      {
                        className: r([
                          "AccordionItem__summary-trailing-icon",
                          {
                            "AccordionItem__summary-trailing-icon--disabled": o,
                            "AccordionItem__summary-trailing-icon--animate": S,
                            "AccordionItem__summary-trailing-icon--open": m
                          }
                        ]),
                        children: /* @__PURE__ */ i(
                          et,
                          {
                            name: "caretUp",
                            "aria-hidden": !1,
                            className: "trailing-icon"
                          }
                        )
                      }
                    )
                  ]
                }
              ),
              N && /* @__PURE__ */ i(
                B,
                {
                  className: "AccordionItem__summary-dropdown",
                  closeOnSelect: n == null ? void 0 : n.closeOnSelect,
                  menuDirection: n == null ? void 0 : n.menuDirection,
                  onChange: n == null ? void 0 : n.onChange,
                  children: (L = n == null ? void 0 : n.items) == null ? void 0 : L.map((e) => /* @__PURE__ */ i(
                    B.Item,
                    {
                      label: e.label,
                      value: e.value
                    },
                    e.label
                  ))
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ i(ct, { children: m && /* @__PURE__ */ i(
          lt,
          {
            initial: "collapsed",
            animate: m ? "open" : "collapsed",
            exit: "collapsed",
            variants: {
              open: {
                height: "auto",
                transitionEnd: {
                  overflow: "unset"
                }
              },
              collapsed: {
                height: 0,
                overflow: "hidden"
              }
            },
            transition: { duration: 0.3, ease: "easeInOut" },
            "aria-labelledby": `accordion-content-${c}`,
            id: `accordion-content-${c}`,
            className: r(["AccordionItem__content", { "AccordionItem__content--disabled": o }]),
            role: "region",
            ...J,
            children: t
          },
          "content"
        ) })
      ]
    }
  );
}, ut = a.div`
  &.AccordionPanel {
    ${({
  theme: {
    components: { accordionV1: t }
  }
}) => s(t.AccordionPanel)};
  }
`, At = ({ content: t, children: l, className: A, dataTestId: c = "ACCORDION_PANEL_DATA_TEST_ID" }) => /* @__PURE__ */ i(
  ut,
  {
    className: r(["AccordionPanel", A]),
    "data-testid": c,
    children: l || t
  }
), It = a.div`
  &.Accordion {
    ${({
  theme: {
    componentStyles: t,
    components: { accordionV1: l }
  }
}) => s(l.AccordionContainer, t)};
  }
`, O = ({
  children: t,
  boxVariation: l,
  singleSelect: A,
  activeAccordionItemId: c = null,
  className: y,
  containerId: g,
  dataTestId: o
}) => {
  const u = P({ label: "Accordion V1" }), [S, _] = j(c);
  return H(() => {
    _(c);
  }, [c]), /* @__PURE__ */ i(
    K.Provider,
    {
      value: {
        isBoxVariant: l,
        isSingleSelect: A,
        activeAccordionItemId: S,
        setActiveAccordionItemId: _
      },
      children: /* @__PURE__ */ i(
        It,
        {
          id: g,
          "data-testid": o,
          className: r([
            "Accordion",
            {
              "Accordion--box": l
            },
            y
          ]),
          ...u,
          children: t
        }
      )
    }
  );
};
O.Item = dt;
O.Panel = At;
export {
  O as Accordion,
  dt as AccordionItem,
  At as AccordionPanel
};
